import { Stack } from 'expo-router';
import React from 'react';

function ReferralsLayout() {
  return <Stack />;
}

export default ReferralsLayout;
